import Vue from 'vue'
import {get,post,put} from './axios'

//get方法
export const getcase = () => get('/5cc14c156ed55a28ad573203/rightrlist/rightlist');
//post方法
export const  postcase =(id)=>post('/5cc14c156ed55a28ad573203/rightrlist/rightlist',{id:id});
//put方法
export const  putcase =(id)=>put('/5cc14c156ed55a28ad573203/rightrlist/rightlist',{id:id});
//delete方法
//export const  deletecase =(id)=>Delete('/5cc14c156ed55a28ad573203/rightrlist/rightlist',{data:{id:id}});


//获取验证码
export const getsendsms = (mobile_account,k,t) => post('/v1/users/sendsms',{
    mobile_account:mobile_account,
    k:k,
    t:t
});


//登陆
export const getlogin = (mobile_account,code) => post('/v1/users/login',{
    mobile_account:mobile_account,code,
    code:code
});





//-----------------------我的-------------------------

//每日海报
export const getdaily = () => get('/v1/mines/dailyposter');

//我的模板
export const getcarttemplate = (page) => get('/v1/mines/template',{page:page});

//意见反馈
export const getfeedback = (json) => post('/v1/mines/feedback',json);

//我的
export const getmines = () => get('/v1/mines');

//更改名片模板
export const updateCarttemplate = (ctid) => put('/v1/mines/bindtemplate/'+ctid)


//我的名片图
export const getmycart = (api_uid) => get('/v1/mines/businesscard',{
  api_uid: api_uid
});

//用户收藏

export const getcollection = (json) => get('/v1/mines/collection',json)

//登出
export const usersLogout = () => post('/v1/users/logout');

//好友请求列表

export const getFriendRequest = () => get('/v1/mines/friend-request-list')

//通过好友
export const friendPass = (id) => post('/v1/mines/friend-pass',{
  id:id
});

//获取用户关注/粉丝列表
export const getRelation = (json) => get('/v1/mines/get-relation',json);


//-----------------------名片模块-------------------------

//个人首页
export const getindexcartMsg = () => get('/v1/users');

//预览他人名片信息
export const cartDetailMsg = (id) => get('/v1/users/' + id);

// 获取个人名片信息
export const getcartmsgById = (id) => get('/v1/users/detail/' + id);

// 创建名片
export const createCart = (json) => post('/v1/users', json)

//扫描出来的数据关联用户
export const saveScanCard = (json) => post('/v1/users/save-scan-card', json)

// 修改个人名片信息
//export const updateCart = (json, id) => put('/v1/users/' + id, json)

//修改个人名片
export const updateCart = (json, id) => post('/v1/users/' + id, json);

//获取名片列表
export const getcartLlist = (json) => get('/v1/users/personas',json);

//消息列表
export const getmessageList = () => get('/v1/private-letters');

//私信列表
export const getWxchatLists = (json,api_uid) => get('/v1/private-letters/' + api_uid,json);

//发送私信
export const subPrivateLetters = (json) => post('/v1/private-letters', json)

//图片上传
export const upimg = (formData) => post('/file-bases/images', formData)

// 靠谱状态修改
export const updateStatus = (api_uid) => put('/v1/users/clicknice', {
  api_uid:api_uid
})

//修改关注状态
export const getclickfollow = (api_uid) => put('/v1/users/clickfollow',{
  api_uid: api_uid
})

//获取微信数据
export const getshareparams = (json) => get('/v1/wx-serves/getshareparams',json);

//交换名片
export const requestFriend = (id) => post('/v1/users/request-friend', {
  id: id
});


//--------------------个人动态和他人动态------------------------

//获取自己的动态  01
export const getmydynamic = (api_uid='',msg_type='',page='') => get('/v1/messages',{
  api_uid:api_uid,
  msg_type:msg_type,
  page:page
});


//获取个人/他人动态
export const getmessage = (json) => get('/v1/messages',json);
 
//获取动态详情
export const getmymessage = (id) => get('/v1/messages/'+id)

//评论/评论回复
export const getcomment = (msg_id='',to_uid='',cid='',content='图片回复',extra='',send_msg) => post('/v1/messages/comment',{
  msg_id:msg_id,
  to_uid:to_uid,
  cid:cid,
  content:content,
  extra:extra,
  send_msg:send_msg
})

//评论/评论回复点赞
export const getnicecomment = (cid,rid="") => post('/v1/messages/nicecomment',{
  cid:cid,
  rid:rid
})

//动态详情鼓掌
export const getnicemsg = (msg_id) => post('/v1/messages/nicemsg', { msg_id:msg_id})

//转发动态页面
export const getforward = (msg_id) => get('/v1/messages/forward', { msg_id:msg_id})

//发布动态

export const getpubishcircle = (content,msg_type,like_id=0,extra='',pid='',) => post('/v1/messages',{
  content:content,
  msg_type:msg_type,
  like_id:like_id,  
  extra:extra,
  pid:pid
});

//关注他人

export const getfollowpeople = (api_uid) => put('/v1/users/clickfollow',{
  api_uid:api_uid
});

//找人
export const findSomeone = (json) => get('/v1/users/find-someone',json)

//删除动态

//export const clearmydynamic = (id) => Delete('/v1/messages/',id);






//-----------------------圈子模块-------------------------

//发现圈子 
export const getFindFuns = (json) => get('/v1/likes/findfuns',json);


//动态点赞
export const gettonicemsg = (msg_id) => post('/v1/messages/nicemsg',{
  msg_id:msg_id
});

//搜索圈子
export const getsearchcircle = (keyword) => get('/v1/likes/searchlike',{
  keyword:keyword
});

//申请圈子列表
export const getApplycircle = (page='0') =>get('/v1/likes/likeapply',{page});



//创建圈子 03

export const getcreatcircle = (group_id,title,avatar_url) => post('/v1/likes',{
  group_id:group_id,
  title:title,
  avatar_url:avatar_url
});

//重新申请圈子
export const getreapplycircle = (json) => put('/v1/likes/' + json.like_id, json);


//圈子首页[关注] 01
export const getfollowcircle = (page='0') => get('/v1/likes',{
  page:page
});

//获取圈子列表 01
export const getcircledylist = (id, msg_type = '0', fromfollow) => get('/v1/likes/'+id,{
  msg_type:msg_type,
  fromfollow:fromfollow
});

//创建圈子选择类型 10
export const getcircletype = () => get('/v1/likes/selectgroup');


//圈子分类展示[推荐] 05

export const getcircleclassify = () => get('/v1/likes/likegroup');


//重现获取圈子列表

export const getothercirclelist = (cirid,page="0") => get('/v1/likes/likegroup',{
  group_id:cirid,
  page:page
});


//最近访问记录  06

export const circlerecentvisits = (page) => get('/v1/likes/recentvisits',{
  page:page
});



//关注圈子  07

export const gettofollowcircle = (like_id) => post('/v1/likes/likefollow',{
  like_id:like_id
});



//Like -签到圈子 12

export const gettoSignincircle = (like_id) => post('/v1/likes/checkinlike',{
  like_id:like_id
});








// 使用全局插件
// var GLOBAL_API = {
//     install(Vue) {
//       Vue.prototype.$gloapi = {
//         getSliderData: function (val) {
//           return get('/top/album?offset=0&limit=5')
//         }
//       };

//     }
//   }

//   Vue.use(GLOBAL_API);



// WEBPACK FOOTER //
// ./src/api/api.js